import createDataContext from './createDataContext'

interface StateType {
    pendingInvoicingData: any
}

interface ActionType {
    payload: any,
    type: string
}

const initialState: StateType = {
    pendingInvoicingData: {}
}

const reducer = (state, action: ActionType) => {

    switch(action.type)
    {
        case 'getPendingInvoicingData': return { ...state, pendingInvoicingData: action.payload }

        default: return state
    }

}

const getPendingInvoicingData = dispatch => {

    return async (variables, getPendingInvoicingData, callback?: (data?) => void, err_callback?: (message?) => void) => {

        try
        {

            const response = await getPendingInvoicingData({ variables })

            dispatch({ type: 'getPendingInvoicingData', payload: response.data?.getAllDocumentsForVendorSortingEntity })

            !!callback ? callback?.(response.data?.getAllDocumentsForVendorSortingEntity) : null

        } catch(e)
        {
            console.log('GET PENDING INVOICING DATA ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

export interface InvoicingPendingInterface {
    state: StateType,
    getPendingInvoicingData: (variables, getPendingInvoicingData, callback?: (data?) => void, err_callback?: (message?) => void) => Promise<void>
}

export const { Context: InvoicingPendingContext, Provider: InvoicingPendingProvider } = createDataContext(reducer,
    { getPendingInvoicingData },
    initialState)
